module.exports = __webpack_public_path__ + "static/media/WSAD_adobe_express.8008d689.svg";